import { Position } from '../../hooks/usePositions';
import { ProductType } from '../../hooks/useProducts';
import { calcPriceFromPct } from '../../lib/calcPriceFromPct';
import { Gwei } from '../../lib/gwei';
import { Input } from '../Input/Input';

interface Props {
  type: 'Gain' | 'Loss';
  setPercentage: (value: bigint | undefined) => void;
  setPrice: (value: bigint | undefined) => void;
  position: Position;
  product: ProductType;
  pnlPercentage: bigint | undefined;
  hasError: boolean;
  customPercentage: bigint | undefined;
}

export const ProfitLossField = ({
  type,
  setPercentage,
  setPrice,
  position,
  product,
  pnlPercentage,
  hasError,
  customPercentage,
}: Props) => {
  return (
    <Input
      label={type}
      inputType="number"
      aria-label={`${type} Percentage`}
      containerClassName="w-24 shrink-0"
      allowNegative={true}
      decimalScale={2}
      rightElement={<span className="text-xs font-bold text-contentSecondary">%</span>}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo.source !== 'event') return;
        if (values.value === '') {
          setPercentage(undefined);
          setPrice(undefined);
          return;
        }

        const percent = Gwei.toGwei(values.value);

        setPercentage(percent);

        // Calculate price based on position type and percentage
        const calculatedPrice = calcPriceFromPct({
          percent,
          side: position.side,
          avgPrice: position.avgPrice,
          tickSize: product.tickSize,
          isStopLoss: type === 'Loss',
        });

        setPrice(calculatedPrice);
      }}
      value={
        customPercentage === undefined
          ? pnlPercentage !== undefined && !hasError
            ? Gwei.fmt(Gwei.abs(pnlPercentage * 100n))
            : ''
          : Gwei.fmt(Gwei.abs(customPercentage))
      }
    />
  );
};
